const initialState = {
  backendUrl: '',
  docsUrl: '',
};

const config = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_CONFIG_SUCCESS':
      return {
        ...state,
        backendUrl: action.backendUrl,
        docsUrl: action.docsUrl,
      };

    default:
      return state;
  }
};

export default config;

export const getApplicationBackendUrl = (state) => state.backendUrl;
export const getApplicationDocsUrl = (state) => state.docsUrl;
